export var OddsModifiers;
(function (OddsModifiers) {
    OddsModifiers["default"] = "default";
    OddsModifiers["changed"] = "changed";
    OddsModifiers["accepted"] = "accepted";
})(OddsModifiers || (OddsModifiers = {}));
//# sourceMappingURL=OddsModifiers.js.map